export default "__VITE_ASSET__xZ9Anwx8__"